import React, {useEffect, useState} from "react";
import Button from "../../components/Button/Button";
import {useNavigate} from "react-router-dom";
import Header from "../../components/Header/Header";
import {instance} from "../../services/services";
import {CERTIFICATION, CERTIFICATION_CHECK, IDFIND_URL} from "../../utils/urls";
import {toast} from "react-toastify";
import {numericRegex} from "../../utils/validation";

// import { verifyPossession } from "../../services/Information/information";

function IdFind() {
    const navigate = useNavigate();
    const [phoneNumber, setPhoneNumber] = useState('');
    const [certification, setCertification] = useState('');
    const [isResendDisabled, setIsResendDisabled] = useState(false);
    const [isTimeOver, setIsTimeOver] = useState(false);
    const [timer, setTimer] = useState(120); // 2분
    const [certificationMsg, setCertificationMsg] = useState('');
    // const [isVerified, setIsVerified] = useState(false); // 인증 완료 여부

    useEffect(() => {
        let interval = null;
        if (isResendDisabled && timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);

        } else if (timer === 0) {
            setIsResendDisabled(false);
            setTimer(120);
            setIsTimeOver(true)

        }
        return () => clearInterval(interval);
    }, [isResendDisabled, timer]);

    const handleBackClick = () => {
        window.history.back();
    };


    const handlePhoneChange = (e) => {
        const numericValue = numericRegex(e.target.value);
        setPhoneNumber(numericValue);
    };

    const handleCertificationChange = (e) => {
        setCertification(e.target.value);
    };

    const handleSendCode = async () => {
        try {
            setIsTimeOver(false)
            const response = await instance.post(CERTIFICATION, {
                userid: '',
                phoneNumber: phoneNumber
            });

            if (response.data.code === 200) {
                // 임시로 인증번호 전송 성공 처리
                setIsResendDisabled(true);
                setTimer(120);
                toast("인증번호가 발송되었습니다.");
            } else {
                toast(response.data.message);
            }


        } catch (error) {
            console.error('인증번호 발송 실패:', error);
        }
    };

    const handleNextClick = async () => {
        try {

            // 1step:: 인증번호 체크
            const certificationRes = await instance.post(CERTIFICATION_CHECK, {
                cert_code: certification,
                phoneNumber: phoneNumber,
                idCheck: 'Y'
            });

            if (certificationRes.data.code === 200) {
                const response = await instance.post(IDFIND_URL, {
                    mem_phone: phoneNumber
                });
                // 2step:: 인증 완료 이후
                if (response.data.code === 200) {
                    navigate('/idFindsuccess', {
                        state: {
                            foundId: response.data.data.userid,
                            snsUserData: response.data.data
                        }
                    });
                } else {
                    navigate('/idfindfail');
                }
            } else {
                setCertificationMsg(certificationRes.data.message);
            }

        } catch (error) {
            console.error(error.response?.data?.message);
        }
    };

    const isValidForm =
        phoneNumber.trim().length > 0 &&
        certification.trim().length === 6;

    return (
        <div className="idfind">
            <div className="content">
                <Header title="아이디 찾기" handleBack={handleBackClick}/>
                <div className="content_body">
                    <div className="nickname_instruction">휴대폰 번호를 입력하시면<br/>인증번호가 발송됩니다</div>
                    <div className="nickname_input_container default_input">
                        <div className="nickname_label label" style={{marginTop: "24px"}}>휴대폰 번호</div>
                        <div style={{position: 'relative'}}>
                            <input
                                type="text"
                                className="nickname_input"
                                value={phoneNumber}
                                onChange={handlePhoneChange}
                                placeholder="휴대폰 번호 입력"
                            />
                            <button
                                className="resend_button"
                                onClick={handleSendCode}
                                disabled={isResendDisabled || !phoneNumber.trim()}
                                style={{position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)'}}
                            >
                                인증번호 전송
                            </button>
                        </div>

                        <div style={{position: 'relative'}}>
                            <input
                                style={{marginTop: "8px"}}
                                type="text"
                                className="nickname_input"
                                maxLength={6}
                                value={certification}
                                onChange={handleCertificationChange}
                                placeholder="인증번호 입력"
                            />
                            {isResendDisabled && (
                                <div className="resend_time">
                                    <span>
                                        {Math.floor(timer / 60)}분 {String(timer % 60).padStart(2, '0')}초
                                    </span>
                                </div>
                            )}
                            {isTimeOver && (
                                <div className="resend_time">
                                    <span>
                                     인증번호 시간이 만료되었습니다.
                                    </span>
                                </div>
                            )}
                            {
                                certificationMsg && <div className="resend_time">
                                    <span>
                                     {certificationMsg}
                                    </span>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div className="Edit_btn_change">
                    <Button
                        label="다음"
                        variant="btn_next"
                        onClick={handleNextClick}
                        disabled={!isValidForm}
                        className={isValidForm ? 'active' : 'disabled'}
                    />
                </div>
            </div>
        </div>
    );
}

export default IdFind;